import { Component } from 'preact';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import style from './styles/ConsentDetail.scss';
import ConsentRepository from '../../../repositories/ConsentRepository';
import LoadingSpinner from '../../spinner/LoadingSpinner';
import HtmlRenderer from '../../html/HtmlRenderer';

class ConsentDetail extends Component {

	isDetailLoaded() {
		const { detailUrl, consentDetails } = this.props;

		return consentDetails.hasOwnProperty(detailUrl);
	}

	fetchDetail() {
		const { detailUrl, fetchConsentDetail } = this.props;

		if (detailUrl && !this.isDetailLoaded(detailUrl)) {
			fetchConsentDetail(detailUrl);
		}
	}

	componentDidMount() {
		this.fetchDetail();
	}

	componentDidUpdate(prevProps) {
		const { detailUrl } = this.props;

		if (prevProps.detailUrl !== detailUrl) {
			this.fetchDetail();
		}
	}

	render({ consentDetails, detailUrl }) {
		const consentDetail = consentDetails[detailUrl];
		if (!this.isDetailLoaded(detailUrl)) {
			return <LoadingSpinner active className="text-center" />;
		}
		if (consentDetail === null) {
			return <h2 className="text-center">Failed to load data</h2>;
		}
		return <HtmlRenderer className={style['consent-html']} html={consentDetail} />;
	}
}

const mapStateToProps = (state) => {
	const {
		consentDetails
	} = state.raffleForm;
	return {
		consentDetails
	};
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
	fetchConsentDetail: ConsentRepository.fetchConsentDetail
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConsentDetail);



// WEBPACK FOOTER //
// ./components/blocks/raffleForm/ConsentDetail.js